// extracted by mini-css-extract-plugin
export default {"header":"S5wkScT2HW4fjZ8huoOg"};